import React from 'react'
import styled from 'styled-components'
import { translate } from '../../../Services/translation'

const SuggestedProductSliderTitle = ({ className = '' }) => {
    return (
        <SuggestedProductTitle className={`uppercase ${className}`}>
            {translate("suggestedproducts-title")}
        </SuggestedProductTitle>
    )
}

const SuggestedProductTitle = styled.div`

`

export default SuggestedProductSliderTitle